import { AppRoutes } from '@/routes';
import { useAuth } from '@/hooks/useAuth';
import { motion } from 'framer-motion';

function App() {
  const { isLoading } = useAuth();

  // CRÍTICO: Aguardar verificação de autenticação
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-black">
        <div className="flex flex-col items-center gap-4">
          <div className="relative w-12 h-12">
            <div className="absolute inset-0 rounded-full border-2 border-black/10 dark:border-white/10"></div>
            <motion.div
              className="absolute inset-0 rounded-full border-2 border-black dark:border-white border-t-transparent"
              animate={{ rotate: 360 }}
              transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
            />
          </div>
          <p className="text-sm text-black/40 dark:text-white/40 font-medium">
            Carregando...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white">
      <AppRoutes />
    </div>
  );
}

export default App;